import { useTheme } from '../theme/ThemeContext'

/**
 * M8 — Fondo estilo Ledgeria: plano y neutro, con un único matiz radial muy
 * sutil de marca en la esquina superior (nada de blobs saturados ni fades).
 */
export default function BackgroundGradient() {
  const { theme } = useTheme()
  const isLight = theme === 'light'

  if (isLight) {
    return (
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0" style={{ background: '#f4f6f8' }} />
        <div
          className="absolute -top-40 -right-40 w-[900px] h-[900px] rounded-full blur-3xl"
          style={{
            background: 'radial-gradient(closest-side, rgba(27,79,216,0.07), rgba(27,79,216,0))',
          }}
        />
      </div>
    )
  }

  return (
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      <div className="absolute inset-0" style={{ background: '#0a1220' }} />
      <div
        className="absolute -top-40 -right-40 w-[900px] h-[900px] rounded-full blur-3xl"
        style={{
          background: 'radial-gradient(closest-side, rgba(46,98,232,0.12), rgba(46,98,232,0))',
        }}
      />
    </div>
  )
}
